import { Modal, Flex, Select } from 'antd';
import { useState, useCallback } from 'react';

import type { SalaryFormat } from '@app/api/ClientServices';
import { CustomInputNumber } from '@app/components';
import {
  SALARY_TYPE_SELECT_OPTIONS,
  SALARY_PERCENT,
} from '@app/pages/Employees/EditEmployee/components/ClientServicesTab/components/ServiceSalaryComponent/data';
import type { SetEmployeeSalaryModalProps } from '@app/pages/Employees/EditEmployee/components/ClientServicesTab/components/SetEmployeeSalaryModal/types';

import '@pages/Employees/EditEmployee/components/ClientServicesTab/components/SetEmployeeSalaryModal/style/SetEmployeeSalaryModal.desktop.scss';

export const SetEmployeeSalaryModal: React.FC<SetEmployeeSalaryModalProps> = ({
  setIsModalOpen,
  isModalOpen,
  handleAddServicesSalaryChange,
}) => {
  const [inputValue, setInputValue] = useState('');
  const [salaryType, setSalaryType] = useState<SalaryFormat>(SALARY_PERCENT);

  const getSalaryIcon = useCallback(() => {
    switch (salaryType) {
      case SALARY_PERCENT:
        return '%';
      default:
        return '';
    }
  }, [salaryType]);

  const cancelModal = () => {
    setIsModalOpen(false);
    setInputValue('');
    setSalaryType(SALARY_PERCENT);
  };

  const handleOk = async () => {
    cancelModal();
    await handleAddServicesSalaryChange(inputValue, salaryType);
  };

  return (
    <Modal
      title="Установить заработную плату"
      open={isModalOpen}
      onOk={handleOk}
      onCancel={cancelModal}
      className="set-employee-salary-modal"
      destroyOnHidden
      afterClose={() => {
        setInputValue('');
        setSalaryType(SALARY_PERCENT);
      }}
    >
      <Flex vertical gap={16}>
        Введите сумму заработной платы
        <Flex gap={16}>
          <Select
            className="salary-type-select"
            options={SALARY_TYPE_SELECT_OPTIONS}
            onChange={(value) => setSalaryType(value)}
            defaultValue={SALARY_PERCENT}
          />
          <CustomInputNumber
            className="salary-value"
            addonAfter={getSalaryIcon()}
            disabled={salaryType === undefined}
            onSuccess={({ value }) => {
              setInputValue(value);
            }}
            isAllowed={(value) =>
              salaryType === SALARY_PERCENT ? value >= 0 && value <= 100 : true
            }
            inputValue={inputValue}
          />
        </Flex>
      </Flex>
    </Modal>
  );
};
